<template>
    <home endpoint="crewmember" :params="params"></home>
</template>

<script>
import home from '@/components/tools/Index'
export default {
  name: 'crewmember',
  components: {
    home,
  },
  data () {
    return {
      params: {
        fields: [
          {name: 'id', label: 'ID', hidden: true},
          {name: 'first_name', label: 'Nombre', required: true},
          {name: 'last_name', label: 'Apellido', required: true},
          {name: 'doc_type', label: 'Tipo de Documento', required: true, editor: 'select', options: [
            {value: 'DNI', label: 'DNI'},
            {value: 'PASSPORT', label: 'PASAPORTE'}
          ]},
          {name: 'doc_number', label: 'Número de Documento', required: true},
          {name: 'doc_expiry_date', label: 'Fecha de Vencimiento', required: true, editor: 'date'},
          {name: 'doc_issue_country', label: 'País de Emisión', required: true},
          {name: 'nationality', label: 'Nacionalidad', required: true},
          {name: 'date_of_birth', label: 'Fecha de Nacimiento', required: true, editor: 'date'},
          {name: 'gender', label: 'Género', required: true, editor: 'select', options: [
            {value: 'MALE', label: 'MASCULINO'},
            {value: 'FEMALE', label: 'FEMENINO'}
          ]},
          {name: 'crew_type', label: 'Tipo de Tripulante', required: true, editor: 'select', options: [
            {value: 'PILOT', label: 'PILOTO'},
            {value: 'COPILOT', label: 'COPILOTO'},
            {value: 'FLIGHT_ATTENDANT', label: 'TRIPULANTE DE CABINA'}
          ]},
          {name: 'is_active', label: 'Activo', editor: 'checkbox'}
        ],
        title: 'Tripulante',
        title2: 'Tripulante'
      }
    }
  },
}
</script> 